import { useSelector } from 'react-redux';
import { FunctionComponent } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { recirculationVideoDataSelector } from '../../../../../common/store/selectors/recirculationVideoData.selector';
import { playerDataSelector } from '../../../../../common/store/selectors/playerData.selector';
import { useStyles } from '../../../../../common/hooks/useStyles';
import { getStorySeekBarProgressStyleObject } from './storySeekBarProgress.style';
import { brandingDataSelector } from '../../../../../common/store/selectors/brandingData.selector';
import { css } from '../../../../../common/styles/styles.utils';

interface StorySeekBarProgressProps {
  index: number;
  currentStoryDuration: number;
}

export const StorySeekBarProgress: FunctionComponent<StorySeekBarProgressProps> = props => {
  const { index, currentStoryDuration } = props;
  const currentScene = useSelector(recirculationVideoDataSelector.currentScene);
  const startOfCurrentScene = useSelector(recirculationVideoDataSelector.startOfCurrentScene);
  const currentVideoTimeFragment = useSelector(playerDataSelector.currentVideoTimeFragment);
  const brandingColor = useSelector(brandingDataSelector.brandingColor);
  const selectedScene = useSelector(recirculationVideoDataSelector.selectedScene);

  const [storyTime, setStoryTime] = useState<number>(-1);
  const [isCurrentStory, setCurrentStory] = useState<boolean>(false);
  const [isStoryEnded, setStoryEnded] = useState<boolean>(false);
  const [isSeeking, setIsSeeking] = useState<boolean>(false);

  const styles = useStyles(getStorySeekBarProgressStyleObject, [isStoryEnded, isCurrentStory, storyTime, currentStoryDuration, isSeeking, brandingColor]);
  const { storyBarProgressStyle } = styles;

  useEffect(() => {
    if (currentScene === index) {
      setCurrentStory(true);
      setStoryTime(currentVideoTimeFragment - startOfCurrentScene);
      setStoryEnded(false);
    } else {
      setCurrentStory(false);
      if (index < currentScene) {
        setStoryEnded(true);
      } else {
        setStoryEnded(false);
      }
    }
  }, [currentVideoTimeFragment, startOfCurrentScene, setStoryEnded, setStoryTime, currentScene, index, setCurrentStory]);

  useEffect(() => {
    if (selectedScene.index !== -1) {
      setIsSeeking(true);
    } else {
      setIsSeeking(false);
    }
  }, [selectedScene, setIsSeeking]);

  return (
    <div style={css(storyBarProgressStyle)} />
  );
};
